// Precisa rodar antes do jquery-migrate: ele lê o migrateMute ao carregar. O Migrate fica ligado em
// todo ambiente (ele devolve a compatibilidade com o jQuery 1.x enquanto o código antigo é
// corrigido), mas só avisa no console em localhost, onde dev e testes rodam. Em hom e produção
// ele é mudo e não gera ruído no console dos clientes.
(function (window) {
  var host = window.location.hostname;
  var local = host === "localhost" || host === "127.0.0.1" || host === "[::1]" || host === "::1";
  window.jQuery.migrateMute = !local;
})(window);
